import {ChangeDetectorRef, Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Kooperationspartner} from '../../../../Api/DcoApi/Kooperationspartner';
import {RestClient} from '../../../../Api/DcoApi/Client/RestClient';
import {Absetzung} from '../../../../Main/Pages/Abrechnung/Absetzung';
import {AbsetzungsDateien} from '../../../../Main/Pages/Abrechnung/Popups/absetzungs-dateien/absetzungs-dateien';
import {DatePipe, NgForOf} from '@angular/common';
import {PhoneCall} from '../../../../Componente/PhoneCall';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';

@Component({
  selector: 'edit-subscription-partner',
  imports: [],
  templateUrl: './edit-subscription-partner.html',
  styleUrl: './edit-subscription-partner.css',
})
export class EditSubscriptionPartner {
  @Input() ids: number[] = []
  @Output() idsChange = new EventEmitter<number[]>();
  Client: RestClient = new RestClient();
  list:Kooperationspartner[] = [];

  constructor() {
    this.LoadData();
  }
  protected async LoadData(){
    this.list = await this.Client.Get<Kooperationspartner[]>('/Backend/Api/V2/Kooperationspartner')
  }

  IsSelected( p:Kooperationspartner)
  {
    return this.ids.includes(p.key);
  }

  select(p:Kooperationspartner)
  {
    if(this.ids.includes(p.key))
    {
      this.ids = this.ids.filter(id => id !== p.key);
    }
    else
    {
      this.ids.push(p.key);
    }
    this.idsChange.emit(this.ids);
  }

}


@Component({
  selector: 'add-subscription',
  imports: [
    Absetzung,
    AbsetzungsDateien,
    DatePipe,
    NgForOf,
    PhoneCall,
    ReactiveFormsModule,
    FormsModule,
    EditSubscriptionPartner
  ],
  templateUrl: './PartnerPopup.html',
})
export class EditSubscriptionPartnerPopup {
  Client: RestClient = new RestClient();
  modal = inject(NgbActiveModal);
  request: number[] = [];
  @Input() Id: string = "";

  constructor(private cdr: ChangeDetectorRef) {

  }

  async init()
  {
    this.request = await this.Client.Get<number[]>(`/Backend/Api/V2/Admin/PushSubscription/${this.Id}/Partner`);
    this.cdr.detectChanges();
  }


  async Save()
  {
    var res = await this.Client.Put<any, number[]>(`/Backend/Api/V2/Admin/PushSubscription/${this.Id}/Partner`, this.request);
    this.modal.close();
  }

}


interface RequestModel {
  type: number;
  url: string;
  name: string;
  partnerIds: number[];
}
